import { Observable } from 'rxjs';

export abstract class UafServiceVM {

    abstract postFormularioUaf(formUaf: any): Observable<any>;

}
